import { Card, Hint, Label, Value } from './styles';

interface KpiCardProps {
  label: string;
  value: string;
  hint?: string;
  accentColor?: string;
}

export function KpiCard({
  label,
  value,
  hint,
  accentColor,
}: KpiCardProps): JSX.Element {
  return (
    <Card
      sx={
        accentColor
          ? { '&::before': { backgroundColor: accentColor } }
          : undefined
      }
    >
      <Label>{label}</Label>
      <Value>{value}</Value>
      {hint && <Hint>{hint}</Hint>}
    </Card>
  );
}
